import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../../api/';
import ParadigmaTable from "../../components/ParadigmaTable/";
import FormatFunctions from "../../functions/functions";
import Tilde from './Tilde.js';

class LotesTable extends Component {
    constructor(props) {
        super(props);
        this.refTable = React.createRef();
        this.state = {
             url:api.vendedores.lotes.replace("$id", props.Loteo_id),
            columns: [
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: true,
                },
                {
                    Header: "Manzana",
                    id: "manzana",
                    accessor: "manzana",
                    className: "text-center",
                    width: 100,
                    show: true,
                },
                {
                    Header: "Número",
                    id: "numero",
                    accessor: "numero",
                    className: "text-center",
                    width: 100,
                    show: true,
                },
                {
                    Header: "¿Puede Venderlo?",
                    className: "text-center",
                    id: "id",
                    Cell: d=>{
                         const id = d.original.id;
                         const state = this.props.LotesPuedeVender_id.filter(elem_id=>id == elem_id).length > 0;
                         return (
                              <Tilde disabled={this.props.disabled} valueChanged={(val1, val2)=> this.props.LotesChanged(val1, val2)} checked={state} id={id}/>
                         );
                    },
                    filterable: false,
                    sortable:true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                             onChange={event => onChange(event.target.value)}
                             style={{ width: "100%" }}
                             value={filter ? filter.value : "TODOS"}>
                             <option value="">TODOS</option>
                             <option value={"True"}>SI</option>
                             <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 150,
                    show: true,
                },
            ]
        };
        this.refTable = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
         const url_new = api.vendedores.lotes.replace("$id", nextProps.Loteo_id);
         const url = this.state.url;

         if (nextProps.Loteo_id != this.props.Loteo_id || url_new != url) {
              this.setState(
                   { url:api.vendedores.lotes.replace("$id", nextProps.Loteo_id)},
                   ()=> this.refTable.current != null && this.refTable.current.gotoFirstPage()
              );
         }
    }

    updateTable(){
         this.refTable.current != null && this.refTable.current.updateTable();
    }

    render() {
        const { data, pages, loading, url } = this.state;
        const { modernTheme, Loteo_id } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                specifyPageInTable={true}
                ref={this.refTable}
                innerRef={this.refTable}
                defaultPageSize={15}
                apiUrl={url}
                columns={this.state.columns}
                title={"Lotes"}
                ref={this.refTable}
                innerRef={this.refTable}
            />
        );
    }
}

export default LotesTable;



// WEBPACK FOOTER //
// ./src/views/Vendedores/LotesTable.js